import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';
import { ScanQrModal } from '../scan-qr/scan-qr.component';

@Component({
	selector: 'app-miles-scan-modal',
	templateUrl: './miles-scan-modal.component.html',
	styleUrls: ['./miles-scan-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MilesScanModalComponent {
  public code = '';
	constructor(private modalCtrl: ModalController, private cdr: ChangeDetectorRef) {}

	static async show(modalCtrl: ModalController): Promise<string> {
		const modal = await modalCtrl.create({
			component: MilesScanModalComponent,
			cssClass: 'auto-height miles-scan-modal',
			componentProps: {},
			showBackdrop: true
		});
		await modal.present();
		await sleep(100);
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

  public async openScanner() {
    const result = await ScanQrModal.show(this.modalCtrl)

    this.code = this.extractLongNumber(result) || ''
    this.cdr.detectChanges()
    console.log(this.code);
    
  };

  closeModal() {
    this.modalCtrl.dismiss(this.code)
  };

	public extractLongNumber(qrString) {
  const match = qrString.match(/\d{10,}/);
  return match ? match[0] : null;
}
}
